/**
 * Room Layout Shared Types
 *
 * Shared TypeScript interfaces for room layout across frontend and backend
 * Date: 09-10-2025 12:40:09
 *
 * @module shared/types/room-layout
 */
/**
 * Room layout error codes
 */
export var LayoutErrorCode;
(function (LayoutErrorCode) {
    LayoutErrorCode["LAYOUT_OVERLAP"] = "LAYOUT_OVERLAP";
    LayoutErrorCode["LAYOUT_OUT_OF_BOUNDS"] = "LAYOUT_OUT_OF_BOUNDS";
    LayoutErrorCode["LAYOUT_NOT_FOUND"] = "LAYOUT_NOT_FOUND";
    LayoutErrorCode["FLOOR_NOT_FOUND"] = "FLOOR_NOT_FOUND";
    LayoutErrorCode["ROOM_NOT_FOUND"] = "ROOM_NOT_FOUND";
    LayoutErrorCode["INSUFFICIENT_PERMISSIONS"] = "INSUFFICIENT_PERMISSIONS";
    LayoutErrorCode["VALIDATION_ERROR"] = "VALIDATION_ERROR";
    LayoutErrorCode["LAYOUT_SAVE_FAILED"] = "LAYOUT_SAVE_FAILED";
    LayoutErrorCode["DELETE_FAILED"] = "DELETE_FAILED";
})(LayoutErrorCode || (LayoutErrorCode = {}));
//# sourceMappingURL=room-layout.js.map